"use client";

import { Link } from "@/components/common/Link";
import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-dark-background text-foreground-dark py-12 md:py-16">
      <div className="container mx-auto px-4">
        {}
        <nav className="flex justify-center mb-8" aria-label="Footer Navigation">
          <ul className="flex flex-wrap justify-center gap-6 md:gap-8 text-sm md:text-base">
            <li>
              <Link to="/HomePage" className="relative inline-block hover:text-accent transition-colors duration-200 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">
                Home
              </Link>
            </li>
            <li>
              <Link to="#programs" className="relative inline-block hover:text-accent transition-colors duration-200 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">
                Programs
              </Link>
            </li>
            <li>
              <Link to="#about" className="relative inline-block hover:text-accent transition-colors duration-200 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">
                About
              </Link>
            </li>
            <li>
              <Link to="#contact" className="relative inline-block hover:text-accent transition-colors duration-200 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">
                Contact
              </Link>
            </li>
          </ul>
        </nav>

        {}
        

        {}
        <div className="text-center text-sm text-foreground-dark/60">
          <p>© 2020&nbsp;Live Entertainment, LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}